import ReadyToLearn from './ReadyToLearn';

export default ReadyToLearn;
